import React, { ButtonHTMLAttributes, useEffect, useRef, useState } from 'react'
import { defPath, fetchPath } from '../../config/defPath'
import { useSession } from '../../hooks/useState'

import { incrementCounter, readCounter } from '../../../utils/counter'
import { generateUniqueID } from '../../../utils/uniqueID'
import { PopsController } from '../../classes/popsController'
import useLocalStorage from "../../hooks/useLocalData"

// @ts-ignore
import Bouncer from "formbouncerjs";
import { TadaPage } from '../../config/types'


// Defining the interface for CodeInputs 
interface CodeInputsProps {
    sendCode: (text: string) => void
    btn: string
}

const userIdTemp = generateUniqueID()

const OptionsTada = () => {
    const [page, setPage] = useState("loading");
    const [data, setData] = useState({ points: 0, coins: 0 });
    const [tadaData, setTadaData] = useState<TadaPage>(null);
    const [error, setError] = useState("Codigo Invalido");
    const [errorTitle, setErrorTitle] = useState("");
    const { addItem } = useLocalStorage()

    const { coins: currentCoins, points: currentPoints } = useSession(state => state)

    const URL_USER = `${fetchPath}/aguila/loyalty/tadacode`
    const URL_NOUSER = `${fetchPath}/aguila/loyalty/code-nouser-tada`
    const NOUSER_ATTEMPTS = 5

    const handleCode = async (tada_code: string) => {
        const isUserAuthenticated = window.drupalSettings.user.uid;
        if (!isUserAuthenticated) {
            if (readCounter() <= NOUSER_ATTEMPTS) {
                try {
                    const res = await fetch(URL_NOUSER, {
                        method: 'POST',
                        body: JSON.stringify({ tada_code, id: userIdTemp })
                    })

                    const resData = await res.json()

                    switch (resData.code) {
                        case 2:
                            addItem('tada', { tada_code, ...resData })
                            new PopsController().open('tada-not-user', resData)
                            const codeForm = document.querySelector<HTMLFormElement>("#tada-form")
                            codeForm && codeForm.reset()
                            break;
                        case 0:
                            incrementCounter()
                            setError(resData.message)
                            setPage("error");
                            window.openAlert({
                                title: `${resData.message}`,
                                type: 'error'
                            })
                            break;
                        default:
                            setError(resData.message)
                            setPage("error");
                            window.openAlert({
                                title: `${resData.message}`,
                                type: 'error'
                            })
                            break;
                    }

                } catch (error) {
                    console.warn(error)
                    setPage("error")
                }
            } else {
                setError("Has realizado demasiados intentos, vuelve a intentarlo mañana")
                setPage("error");
            }
        } else {

            try {
                const res = await fetch(URL_USER, {
                    method: 'POST',
                    body: JSON.stringify({ tada_code })
                })

                const { message, coins, points, type, total, popup, redirect, title } = await res.json()

                switch (message) {
                    case "Código redimido con éxito.":
                        if(redirect) {
                            window.location.href = redirect
                            return
                        }

                        setData({ points, coins })
                        setPage("success");
                        var typecode = 'TaDa'
                        if (points == 100) {
                            var typecode = 'Tapa'
                        }
                        window.dataLayer.push({
                            'event': 'GAEvent',
                            'event_category': 'Content',
                            'event_action': 'Content',
                            'event_label': 'You won points and coins - ' + typecode,
                            'interaction': 'true',
                            'component_name': 'Modo_Carrera_Codes',
                            'element_text': 'Acumulaste puntos y sumaste más monedas',
                        });

                        if (total.coins && total.points) {
                            useSession.setState({ coins: parseInt(total.coins) })
                            useSession.setState({ points: parseInt(total.points) })
                        }

                        window.openAlert({
                            title: `¡WOW! ¡ACUMULASTE PUNTOS Y SUMASTE MÁS MONEDAS!`,
                        })

                        if (popup) {
                            setTimeout(() => {
                                window.openAlert({
                                    title: `${popup}`,
                                    time: 6000
                                })
                            }, 6000)
                        }

                        break;
                    case "Código inválido.":
                        setPage("error");
                        var typeCode = type ? ` - ${type}` : ''
                        window.dataLayer.push({
                            'event': 'GAEvent',
                            'event_category': 'Content',
                            'event_action': 'Content',
                            'event_label': `Invalid code${typeCode}`,
                            'interaction': 'true',
                            'component_name': 'Modo_Carrera_Codes',
                            'element_text': 'Código inválido',
                        });
                        break;
                    default:
                        setError(message)
                        setErrorTitle(title)
                        setPage("error");
                        var typeCode = type ? ` - ${type}` : ''
                        window.dataLayer.push({
                            'event': 'GAEvent',
                            'event_category': 'Content',
                            'event_action': 'Content',
                            'event_label': `Invalid code${typeCode}`,
                            'interaction': 'true',
                            'component_name': 'Modo_Carrera_Codes',
                            'element_text': 'Código inválido',
                        });
                        break;
                }

            } catch (error) {
                console.warn(error)
                setPage("error")
            }
        }

    }

    function handleBtnOtherCode(event: any) {
        setPage("default");
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': 'Enter another code - You won points and coins',
            'interaction': 'true',
            'component_name': 'Modo_Carrera_Codes',
            'element_text': 'Ingresar otro código',
        });
    }
    function handleBtnOtherCodeError(event: any) {
        setPage("landing");
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': 'Enter another code - Invalid code',
            'interaction': 'true',
            'component_name': 'Modo_Carrera_Codes',
            'element_text': 'Ingresar otro código',
        });
    }
    function handleBtnRanking(event: any) {
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': 'See ranking - You won points and coins',
            'interaction': 'true',
            'component_name': 'Modo_Carrera_Codes',
            'element_text': 'Ver ranking',
        });
    }

    useEffect(() => {
    
        fetch(`${fetchPath}/aguila/loyalty/get-tada`)
            .then(res => res.json() as Promise<TadaPage>)
            .then(data => {
                setTadaData(data)
                setPage("landing")
            })
            .catch(err => {
                setPage("error")
            })

    }, [])

    return (
        <>
            {page === "loading" && <div className="tadaSection__top"></div>}

            {page === "landing" &&
                <div className="tadaSection__top">
                    <h1 className='titleSection ar__title' dangerouslySetInnerHTML={{ __html: tadaData.landing.title.value }}></h1>
                    <div className='textSection' dangerouslySetInnerHTML={{ __html: tadaData.landing.subtitle.value }}></div>
                    {/* Passing the correct interface to CodeInputs */}
                    <CodeInputs btn={tadaData.landing.btn1} sendCode={(code: string) => handleCode(code)} />
                </div>
            }

            {page === "success" &&
                <div className="tadaSection__top">
                    <div className='titleSection titleSection--point ar__title'><span className='fontMedium'>+<span className='fontBig'>{data.points}</span>PTS</span><span>+{data.coins} <img src={`${defPath}/assets/images/icons/coins.png`} alt="imagen monedas" /></span></div>
                    <h1 className='textSection' dangerouslySetInnerHTML={{ __html: tadaData.confirm.title.value }}></h1>
                    <div className='textSection' dangerouslySetInnerHTML={{ __html: tadaData.confirm.subtitle.value }}></div>
                    <br />
                    <div className="btnSection">
                        {
                            tadaData.confirm.btn1 && (
                                <a 
                                    href={tadaData.confirm.url1}
                                    className="ar__btn-primary"
                                    style={{ paddingInline: "5rem"}}
                                >
                                    { tadaData.confirm.btn1 }
                                </a>
                            )
                        }
                        {
                            tadaData.confirm.btn2 && (
                                <a 
                                    href={tadaData.confirm.url2}
                                    className="ar__btn-secondary"
                                    style={{ paddingInline: "4rem", border: "2px solid #fff" }}
                                >
                                    { tadaData.confirm.btn2 }
                                </a>
                            )
                        }
                    </div>
                </div>
            }

            {page === "error" &&
                <div className="tadaSection__top">
                    <h1 className='titleSection ar__title' dangerouslySetInnerHTML={{ __html: errorTitle ? errorTitle : `Código<span>Inválido</span>` }}></h1>
                    <p className='textSection' dangerouslySetInnerHTML={{ __html: error }}></p>
                    {/* <button onClick={handleBtnOtherCodeError} className="ar__btn-primary">Ingresa otro código</button> */}
                    <ButtonBlue onClick={handleBtnOtherCodeError}>Ingresa otro código</ButtonBlue>
                </div>
            }
        </>
    )
}

export default OptionsTada

const CodeInputs: React.FC<CodeInputsProps> = ({ sendCode, btn }) => {
    const [error, setError] = useState(false);
    const [inputCompleted, setInputCompleted] = useState(false);

    const refForm = useRef<HTMLFormElement>(null)

    const inputRefs = [
        useRef<HTMLInputElement>(null),
        useRef<HTMLInputElement>(null),
        useRef<HTMLInputElement>(null),
        useRef<HTMLInputElement>(null),
        useRef<HTMLInputElement>(null),
        useRef<HTMLInputElement>(null),
        useRef<HTMLInputElement>(null)
    ];

    function handleInputChange(index: number, event: any) {
        setError(false)
        const input = event.target;
        const value = input.value;

        if (value) {
            if (index < inputRefs.length - 1) {
                inputRefs[index + 1].current!.focus();
                inputRefs[index + 1].current!.select();
            } else {
                let complete: any[] = []
                inputRefs.forEach(element => {
                    if (element.current && !element.current.value.length) {
                        complete.push(element.current)
                    }
                })
                if (complete.length !== 0) {
                    setInputCompleted(false)
                } else {
                    setInputCompleted(true)
                }
            }
        } else {
            if (index > 0) {
                inputRefs[index - 1].current!.focus();
                inputRefs[index - 1].current!.select();
            }
        }
    }

    function handleKeyDown(index: number, event: any) {
        if (event.keyCode === 8 && !event.target.value) {
            if (index > 0) {
                event.preventDefault();
                inputRefs[index - 1].current!.focus();
                inputRefs[index - 1].current!.select();
            }
        }
        if (event.keyCode === 8) {
            if (index > 0) {
                setInputCompleted(false)
            }
        }
    }

    function handleClick(event: any) {
        event.preventDefault()

        // Validate the field
        var bouncer = Bouncer();
        var areValid = bouncer.validateAll(refForm.current);
        setError(areValid);

        // Checking if all the inputs have a valid value
        const codeArr: string[] = inputRefs.map(input => {
            return input.current!.value || ""
        })

        const codeStr = codeArr.join('').toUpperCase()

        sendCode(codeStr)

        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': 'Submit code - Tada',
            'interaction': 'true',
            'component_name': 'Modo_Carrera_Codes',
            'element_text': event.currentTarget.textContent,
        });

    }

    function handlePaste(event: any) {
        event.preventDefault();
        const copy = event.clipboardData.getData('text/plain')
        inputRefs.forEach((input, index) => {
            if (copy[index]) input.current!.value = copy[index]
            input.current!.focus();
        })

        if (inputRefs[inputRefs.length - 1].current!.value) setInputCompleted(true)
    };

    return (
        <>
            <form ref={refForm} onSubmit={handleClick} id="tada-form">
                <div className={`boxCode`}> {/** ${error ? 'form-error' : ''} */}
                    {[...Array(7)].map((_, index) => (
                        <input
                            key={index}
                            className={'boxCode--input'}
                            placeholder="_"
                            type="text"
                            maxLength={1}
                            ref={inputRefs[index]}
                            onChange={(event) => handleInputChange(index, event)}
                            onKeyDown={(event) => handleKeyDown(index, event)}
                            required={true}
                            onPaste={handlePaste}
                        />
                    ))}
                </div>
                <ButtonBlue 
                    onClick={handleClick} 
                    disabled={!inputCompleted}
                >
                    { btn }
                </ButtonBlue>
            </form>

        </>
    );
}

const ButtonYellow: React.FC<ButtonHTMLAttributes<HTMLButtonElement>> = (props) => {
    return (
        <button 
            disabled={props.disabled} 
            className={`ar__btn-primary`}
            onClick={props.onClick}
            {...props}
        >
            {props.children}
        </button>
    )
}

const ButtonBlue: React.FC<ButtonHTMLAttributes<HTMLButtonElement>> = (props) => {
    return (
        <button 
            disabled={props.disabled} 
            className={`ar__btn-secondary`}
            onClick={props.onClick}
            style={{ border: "2px solid #fff"}}
            {...props}
        >
            {props.children}
        </button>
    )
}